module.exports = __webpack_public_path__ + "img/Group 4641.1f7cc0cf.png";